export const BYTES = 'Byte Sequence';
//# sourceMappingURL=BYTES.js.map